// Vendors
import * as yup from 'yup';
import { DateTime } from 'luxon';

export const txrc = {
  APP_RULES: {
    txrclicenserenewal: {
      linkService: {
         licenseNumber: yup.string().trim().matches(/^[0-9]{8}$/, { id: 'txrc_licenseNumber_error' }).required({ id: 'txrc_licenseNumber_error' }),
        lastName: yup.string().trim().matches(/^[a-zA-Z\\s'-]+$/, { id: 'txrc_lastName_error' }).required({ id: 'txrc_lastName_error' }),
      },
    },
  },
};
